import PropTypes from 'prop-types';
import {useEffect, useRef, useState} from 'react';
import InputMask from 'react-input-mask';
import Translation from '../../v2/lang/Translation';
import {isCardTypeValidForChunking} from '../../v2/selectors/isCardTypeValidForChunking';
import getShouldPerformCardNumberChunking from '../../v2/selectors/getShouldPerformCardNumberChunking';
import store from '../../v2/store/store';
import {
  calculateMaskWhenCardTypeInvalidForChunking,
  calculateMaskWhenCardTypeValidForChunking,
} from '../../v2/utils/CardChunkingUtils';

export function InputMaskInput(props) {
  const [maskValue, setMaskValue] = useState('');
  const inputRef = useRef(null);
  const [mask, setMask] = useState('');
  
  useEffect(() => {
    if (props.id === 'credit-card-num' && getShouldPerformCardNumberChunking(store.getState())) {
      if (maskValue && isCardTypeValidForChunking(maskValue)) {
        setMask(calculateMaskWhenCardTypeValidForChunking(maskValue));
      } else {
        setMask(calculateMaskWhenCardTypeInvalidForChunking(maskValue));
      }
    }
  }, [maskValue]);
  
  const handleChange = (event) => {
    setMaskValue(event.target.value);
    props.onChange(event);
  };
  
  return (
    <InputMask
      onChange={handleChange}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      mask={mask}
      maskChar={null}
      value={props.value}
      disabled={props.disabled}
      id={props.id}
      className={props.className}
      placeholder={props.placeholder ? Translation.getText(props.placeholder) : ''}
      name={props.name}
    >
      {inputProps => <input ref={inputRef} {...inputProps} type="text" />}
    </InputMask>
  );
}

InputMaskInput.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
};

InputMaskInput.defaultProps = {
  disabled: false,
  onChange: () => {
  },
};

export default InputMaskInput;
